<template>
  <div v-loading="loading" class="alarmClass">
    <div :style="contentStyle">
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <!-- <el-col :span="12">
              <el-form-item label="老人姓名" prop="name">
                
                <el-input
                clearable
                 :disabled="model==='view'" v-model="form.name"
                placeholder="自理情况"
                maxlength="100"
              ></el-input>
              </el-form-item>
            </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="床位号" prop="bedNumber">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.bedNumber"
                placeholder="请输入床位号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="登记时间" prop="registrationTime">
              <!-- <el-input
                clearable
                 :disabled="model==='view'" v-model="form.registrationTime"
                placeholder="登记时间"
                maxlength="100"
              ></el-input> -->
              
              <el-date-picker 
                style="width: 100%;" 
                value-format="yyyy-MM-dd HH:mm:ss" 
                 :disabled="model==='view'" v-model="form.registrationTime" 
                type="date" 
                placeholder="请选择登记时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登记人" prop="registranter">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.registranter"
                placeholder="请输入登记人"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体检医院" prop="examinationHospital">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.examinationHospital"
                placeholder="请输入体检医院"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体检时间" prop="examinationTime">
              <!-- <el-input
                clearable
                 :disabled="model==='view'" v-model="form.examinationTime"
                placeholder="体检时间"
                maxlength="100"
              ></el-input> -->
              
              <el-date-picker 
                style="width: 100%;" 
                value-format="yyyy-MM-dd HH:mm:ss" 
                 :disabled="model==='view'" v-model="form.examinationTime" 
                type="date" 
                placeholder="请选择体检时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="体检结果" prop="examinationResult">
              <el-input
              type="textarea"
                clearable
                 :disabled="model==='view'" v-model="form.examinationResult"
                placeholder="请输入体检结果"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="体检图片" prop="examinationPictureUrlList">
              <vUpload
                :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多1张'"
                :types="['jpg', 'png']"
                :max="5242880"
                :limit="1"
                 :disabled="model==='view'" 
                :fileList.sync="form.examinationPictureUrlList"
              ></vUpload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="title">基本体征</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身高" prop="height">
              <money-input
                placeholder="请输入身高"
                 :disabled="model==='view'" v-model="form.height"
                templateName="cm"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="体重" prop="weight">
              <money-input
                placeholder="请输入体重"
                 :disabled="model==='view'" v-model="form.weight"
                templateName="Kg"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体温" prop="temperature">
              <money-input
                placeholder="请输入体温"
                 :disabled="model==='view'" v-model="form.temperature"
                templateName="°C"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="title">血压-血氧信息</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="高压" prop="highTension">
              <money-input
                placeholder="请输入高压"
                 :disabled="model==='view'" v-model="form.highTension"
                templateName="mmHg"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="低压" prop="lowPressure">
              <money-input
                placeholder="请输入低压"
                 :disabled="model==='view'" v-model="form.lowPressure"
                templateName="mmHg"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="脉搏" prop="pulse">
              <money-input
                placeholder="请输入脉搏"
                 :disabled="model==='view'" v-model="form.pulse"
                templateName="次/分"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="血氧值" prop="bloodOxygen">
              <money-input
                placeholder="请输入血氧值"
                 :disabled="model==='view'" v-model="form.bloodOxygen"
                templateName="%"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <div class="title">血糖信息</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="空腹血糖" prop="fastingBloodGlucose">
              <money-input
                placeholder="请输入空腹血糖"
                 :disabled="model==='view'" v-model="form.fastingBloodGlucose"
                templateName="毫摩尔/升"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="餐后血糖" prop="postprandialBloodGlucose">
              <money-input
                placeholder="请输入餐后血糖"
                 :disabled="model==='view'" v-model="form.postprandialBloodGlucose"
                templateName="毫摩尔/升"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="title">血脂信息</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总胆固醇" prop="totalCholesterol">
              <money-input
                placeholder="请输入总胆固醇"
                 :disabled="model==='view'" v-model="form.totalCholesterol"
                templateName="mmol/L"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="高密度脂蛋白胆固醇" prop="highDensityLipoproteinCholesterol">
              <money-input
                placeholder="请输入高密度脂蛋白胆固醇"
                 :disabled="model==='view'" v-model="form.highDensityLipoproteinCholesterol"
                templateName="mmol/L"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="甘油三酯" prop="triglyceride">
              <money-input
                placeholder="请输入甘油三酯"
                 :disabled="model==='view'" v-model="form.triglyceride"
                templateName="mmol/L"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="低密度脂蛋白胆固醇" prop="lowDensityLipoproteinCholesterol">
              <money-input
                placeholder="请输入低密度脂蛋白胆固醇"
                 :disabled="model==='view'" v-model="form.lowDensityLipoproteinCholesterol"
                templateName="mmol/L"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="尿酸" prop="uricAcid">
              <money-input
                placeholder="请输入尿酸"
                 :disabled="model==='view'" v-model="form.uricAcid"
                templateName="mmol/L"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <div class="title">心电信息</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="qrs间期" prop="qrsInterval">
              <money-input 
                placeholder="请输入qrs间期" 
                 :disabled="model==='view'" v-model="form.qrsInterval" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="全科医生批注" prop="practitionerNote">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.practitionerNote"
                placeholder="请输入全科医生批注"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="rr间期" prop="rrInterval">
              <money-input
                placeholder="请输入rr间期"  :disabled="model==='view'" v-model="form.rrInterval" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医生分析结果" prop="analysisResult">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.analysisResult"
                placeholder="请输入医生分析结果"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="心率" prop="heartRate">
              <money-input
                placeholder="请输入心率"
                 :disabled="model==='view'" v-model="form.heartRate"
                templateName="次/分"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
  <script>
import vUpload from "../components/mutil-upload.vue"
  import { saveMedicalTestInfo,getPhysicalDetail
} from '../api/serveItemManage';
import { getStore } from '@/util/store';
export default {
    components: {vUpload},
  // components: {},
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      form: {
        name: '',
      },
      contentStyle: '',
      formRules: {
        name: [{ required: true, message: '物料名称不能为空', trigger: 'blur' }],
        nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  watch: {},
  methods: {
    calcHeight() {
      let bodyHight = document.body.clientHeight;
      let contentHeight = bodyHight - 340;
      this.contentStyle =
        'max-height:' + contentHeight + 'px; overflow-y: scroll;overflow-x: hidden;';
    },

    async initData() {
      if(getStore({name:'elderId'})){
        getPhysicalDetail({elderlyId: getStore({name:'elderId'})}).then((res)=>{
          this.form = res.data;
        });
      }
      if (this.model == 'add') {
      } else {
      }
    },
    saveRecord(cb) {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
        if(result){
            saveMedicalTestInfo({elderlyId:getStore({name:'elderId'}),...this.form}).then((res)=>{
              this.$message.success('操作成功！');
              this.$emit('success', this.form);
            if(cb)cb();
            });
          // saveMedicalTestInfo(this.form).then((res)=>{
          //   this.$message.success('操作成功！',res);
          //   // setStore({
          //   //   name: 'elderId',
          //   //   content: res.data
          //   // })
          // });
        }
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
.title {
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}
</style>
  